import { render, staticRenderFns } from "./AverageDeliveryTime.vue?vue&type=template&id=39aa799e"
import script from "./AverageDeliveryTime.vue?vue&type=script&lang=js"
export * from "./AverageDeliveryTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports